<template>
  <v-app id="login" class="primary">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md6 lg4 xl3>
            <v-card class="elevation-1 pa-3">
              <v-card-text>
                <div class="layout column align-center">
                  <br />
                  <img
                    src="/static/logo.png"
                    alt="Vue Material Admin"
                    width="240"
                  />
                  <h2 class="flex my-4 primary--text">Đăng nhập</h2>
                </div>
                <v-form>
                  <v-text-field
                    append-icon="person"
                    name="login"
                    label="Số điện thoại hoặc email"
                    type="text"
                    v-model="model.username"
                  ></v-text-field>
                  <v-text-field
                    name="password"
                    label="Mật khẩu"
                    id="password"
                    v-model="model.password"
                    :append-icon="
                      isShowPassword ? `visibility_off` : `visibility`
                    "
                    :type="isShowPassword ? `text` : `password`"
                    @click:append="isShowPassword = !isShowPassword"
                    @keypress.enter="login()"
                  ></v-text-field>
                  <br />
                  <v-btn
                    block
                    round
                    color="black"
                    @click="login"
                    :loading="loading"
                    class="login-btn"
                    >Đăng nhập</v-btn
                  >
                  <br />
                  <p class="text-xs-center mb-1">Hoặc đăng nhập bằng</p>
                  <v-layout row wrap justify-center class="pb-2">
                    <v-btn
                      id="signInGoogle"
                      class="btn-link"
                      depressed
                      :loading="loadingGoogle"
                    >
                      <img
                        src="/static/icons/icon-google-normal.png"
                        class="btn-icon"
                      />
                      <span class="pl-2">Google</span>
                    </v-btn>
                    <v-btn
                      id="signInFacebook"
                      class="btn-link"
                      depressed
                      :loading="loadingFacebook"
                      @click="signInWithFacebook"
                    >
                      <img
                        src="/static/icons/icon-facebook.png"
                        class="btn-icon"
                      />
                      <span class="pl-2">Facebook</span>
                    </v-btn>
                    <v-btn
                      id="signInZalo"
                      class="btn-link"
                      depressed
                      :loading="loadingZalo"
                      @click="requestPermissionUserZalo"
                    >
                      <img src="/static/icons/icon-zalo.png" class="btn-icon" />
                      <span class="pl-2">Zalo</span>
                    </v-btn>
                  </v-layout>
                  <v-layout align-center justify-center>
                    <v-btn flat small to="/forgotpassword">Quên mật khẩu</v-btn>
                    <v-btn flat small to="/register">Đăng ký</v-btn>
                    <v-btn flat small @click="trial()">Dùng thử</v-btn>
                  </v-layout>
                </v-form>
              </v-card-text>
              <!-- <v-card-actions>
                <v-btn icon>
                  <v-icon color='blue'>fa fa-facebook-square fa-lg</v-icon>
                </v-btn>
                <v-btn icon>
                  <v-icon color='red'>fa fa-google fa-lg</v-icon>
                </v-btn>
                <v-btn icon>
                  <v-icon color='light-blue'>fa fa-twitter fa-lg</v-icon>
                </v-btn>
                            </v-card-actions>-->
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <v-footer height="auto" class="white pa-3 app--footer">
      <v-spacer />
      <span class="caption">Vietmap Motrak Web App v1.6d</span>
      <v-spacer />
    </v-footer>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import * as Utils from '@/utils/index';
import axios from 'axios';
import * as Auth from '@/utils/auth';

export default {
  data: () => ({
    loading: false,
    isShowPassword: false, 
    model: {
      username: '',
      password: '',
    },
    loadingGoogle: false,
    loadingFacebook: false,
    loadingZalo: false,
  }),
  computed: {
    ...mapGetters(['loggedUser']),
  },

  created () {
    this.loginZaloUser();
    this.initSigninFacebook();
  },

  mounted () {
    // this.onSignIn();
    // this.renderButton();
    this.initSignInGoogle();
  },

  methods: {
    ...mapActions([
      'loginByUsername',
      'getUserInfo',
      'loginFacebook',
      'loginGoogle',
      'loginZalo',
      'getAccesstokenZalo',
    ]),
    login () {
      this.loading = true;
      this.loginByUsername({
        username: this.model.username.trim(),
        password: this.model.password,
      })
        .then(() => {
          this.loading = false;
          window.getApp.$emit('APP_LOGIN_SUCCESS');
          // this.$router.push({ path: '/' });
        })
        .catch((_) => {
          this.loading = false;
          window.getApp.showMessage('Sai tên đăng nhập hoặc mật khẩu', 'error');
        });
    },
    trial () {
      this.loading = true;
      const model = {
        username: '12345678901',
        password: '123456',
      };
      this.loginByUsername(model)
        .then(() => {
          this.loading = false;
          this.$router.push({ path: '/' });
        })
        .catch((_) => {
          this.loading = false;
          window.getApp.showMessage('Sai tên đăng nhập hoặc mật khẩu', 'error');
        });
    },

    signOut () {
      console.log('signOut -> window.gapi', window.gapi);
      let auth2 = window.gapi.auth2.getAuthInstance();
      auth2.signOut().then(function () {
        console.log('User signed out.');
      });
    },

    // Config signin with google
    initSignInGoogle () {
      window.gapi.load('auth2', () => {
        // Retrieve the singleton for the GoogleAuth library and set up the client.
        let auth2 = window.gapi.auth2.init({
          client_id: `${Utils.ClientIdOAuth2}.apps.googleusercontent.com`,
          cookiepolicy: 'single_host_origin',
          // Request scopes in addition to 'profile' and 'email'
          // scope: 'additional_scope'
        });

        let element = document.getElementById('signInGoogle');
        if (!element) return;
        // Trả về kết quả khi đăng nhập account google thành công
        auth2.attachClickHandler(
          element,
          {},
          (googleUser) => {
            let accessToken = googleUser.getAuthResponse(true).access_token;

            this.loadingGoogle = true;
            this.loginGoogle({ accessToken })
              .then((res) => {
                window.getApp.$emit('APP_LOGIN_SUCCESS');
                this.loadingGoogle = false;
              })
              .catch((err) => {
                window.getApp.showMessage(
                  'Tài khoản đăng nhập không đúng hoặc chưa được liên kết!',
                  'error'
                );
                this.loadingGoogle = false;
                return err;
              });
          },
          function (error) {
            console.log('initSignInGoogle -> error', error);
            window.getApp.showMessage(
              'Tài khoản đăng nhập không đúng hoặc chưa được liên kết!',
              'error'
            );
          }
        );
      });
    },

    // Config signin width facebook
    initSigninFacebook () {
      window.fbAsyncInit = () => {
        window.FB.init({
          appId: Utils.AppIdFacebook,
          autoLogAppEvents: true,
          xfbml: true,
          version: 'v8.0',
        });

        // This function should be here, inside window.fbAsyncInit
        window.FB.getLoginStatus(function (response) {
          // console.log('window.fbAsyncInit -> response', response);
        });
      };

      (function (d, s, id) {
        let js;
        let fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {
          return;
        }
        js = d.createElement(s);
        js.id = id;
        js.src = '//connect.facebook.net/en_US/sdk.js';
        fjs.parentNode.insertBefore(js, fjs);
      })(document, 'script', 'facebook-jssdk');
    },

    signInWithFacebook () {
      window.FB.login((response) => {
        console.log('signInWithFacebook -> response', response);
        if (!response.authResponse) return;
        this.loadingFacebook = true;
        this.loginFacebook({
          accessToken:
            response.authResponse && response.authResponse.accessToken,
        })
          .then((res) => {
            window.getApp.$emit('APP_LOGIN_SUCCESS');
            this.loadingFacebook = false;
          })
          .catch((err) => {
            console.log('signInWithFacebook -> err', err);
            this.loadingFacebook = false;
            window.getApp.showMessage(
              'Tài khoản đăng nhập không đúng hoặc chưa được liên kết!',
              'error'
            );
          });
      });
    },

    logOutFB () {
      window.FB.logout(function (response) {
        console.log('logOutFB -> response', response);
        document.location.reload();
        // user is now logged out
      });
    },

    // Yêu cầu cấp quyền cho User Zalo
    requestPermissionUserZalo () {
      let encodeLink = 'https%3A%2F%2Fweb.motrak.vn%2F%23%2Flogin';
      window.location.href = `https://oauth.zaloapp.com/v3/permission?app_id=${Utils.AppIdZalo}&redirect_uri=${encodeLink}&state=true`;
    },

    async loginZaloUser () {
      if (Auth.getCodeZaloUser()) {
        console.log(
          'loginZaloUser -> Auth.getCodeZaloUser()',
          Auth.getCodeZaloUser()
        );
        // Lấy oAuthCode user zalo đã lưu khi yêu cầu cấp quyền cho User Zalo trả về
        let oAuthCode = Auth.getCodeZaloUser();
        this.loadingZalo = true;
        await this.loginZalo({ oAuthCode })
          .then((_) => {
            window.getApp.$emit('APP_LOGIN_SUCCESS');
            Auth.removeCodeZaloUser();
            this.loadingZalo = false;
          })
          .catch((err) => {
            this.loadingZalo = false;
            Auth.removeCodeZaloUser();
            console.log('loginZaloUser -> err', err);
            window.getApp.showMessage(
              'Tài khoản đăng nhập không đúng hoặc chưa được liên kết!',
              'error'
            );
          });
      }
    },
  },
};
</script>
<style scoped lang="css">
#login {
  height: 50%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: '';
  z-index: 0;
}
.login-btn {
  color: white !important;
}
.btn-icon {
  height: 19px;
  width: 19px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue